import React, { useContext } from 'react';
import { TeApiContext } from '@ecommerce/nest-ssr/common';
import classNames from 'classnames';
import WidgetPhotosTeaserCircleProps
    from './widget-photos-teaser-circle.props';
import WidgetCoupon from 'modules/shared/widgets/shared/widget-coupon';
import WidgetPhotosTeaserCircleBoxes
    from 'modules/shared/widgets/components/widget-photos-teaser-circle/components/widget-photos-teaser-circle-boxes';
import WidgetPhotosTeaserCircleCircles
    from 'modules/shared/widgets/components/widget-photos-teaser-circle/components/widget-photos-teaser-circle-circles';

import './widget-photos-teaser-circle.scss';

const WidgetPhotosTeaserCircle: React.FC<WidgetPhotosTeaserCircleProps> = ({ config, data }) => {
    const api = useContext(TeApiContext);

    if (api === null) {
        throw new Error('Invalid API context');
    }

    return (
        <div className="w-photos-teaser-circle">
            <div className={classNames({
                'w-photos-teaser-circle__top': true,
                'w-photos-teaser-circle__top--d': api.getDevice() === 'desktop'
            })}
            >
                <div className={classNames({
                    'w-photos-teaser-circle__top__coupon': true,
                    'w-photos-teaser-circle__top__coupon--d': api.getDevice() === 'desktop'
                })}
                >
                    <WidgetCoupon coupon={config?.coupon || []} />
                </div>
                <div className="w-photos-teaser-circle__top__boxes">
                    <WidgetPhotosTeaserCircleBoxes boxes={data.boxes} />
                </div>
            </div>
            <div className="w-photos-teaser-circle__bottom">
                <WidgetPhotosTeaserCircleCircles circles={data.circles} />
            </div>
        </div>
    );
};

export default WidgetPhotosTeaserCircle;
